const translations = {
  clustering: 'Agrupamento',
  showUsers: 'Mostrar usuários',
  showPlaces: 'Mostrar locais',
  route: 'Rota',
  selectUserAndHours: 'Selecione o usuário e as últimas horas percorridas.',
  user: 'Usuário',
  lastHours: 'Últimas horas',
  search: 'Pesquisar',
  removeRoute: 'Remover rota',
  selectUserError: 'Selecione um usuário.',
  setHoursError: 'Defina a quantidade de horas.'
}

export default translations
